import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { SvgIconTypeMap } from '@mui/material';
import { MoreVert } from '@material-ui/icons';

export interface MenuMoreItem {
  caption?: string;
  icon?: any;
  disabled?: boolean;
  color: any;
  /* eslint-disable */
  renderMenuItem?: (item: MenuMoreItem) => JSX.Element;
  /* eslint-enable */
  onClick?: () => void;
}
interface MenuMoreProps {
  icon?: SvgIconTypeMap;
  disabled?: boolean;
  items: MenuMoreItem[];
}

export default function MenuMore({ icon, disabled, items }: MenuMoreProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const IconComponent = icon ?? <MoreVert />;

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="menu-more"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={!items.length || disabled}
        size="small"
      >
        {IconComponent}
      </IconButton>
      <Menu
        id="menu-more"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {items.map((item, idx) =>
          item.renderMenuItem ? (
            <React.Fragment key={idx}>{item.renderMenuItem(item)}</React.Fragment>
          ) : (
            <MenuItem
              key={idx}
              disabled={item.disabled}
              style={{ color: item.disabled ? undefined : item.color }}
              onClick={() => {
                handleClose();
                item.onClick?.();
              }}
            >
              {item.icon && <ListItemIcon>{item.icon ?? ''}</ListItemIcon>}
              <ListItemText primary={item.caption} />
            </MenuItem>
          ),
        )}
      </Menu>
    </>
  );
}
